import { Route, Routes } from 'react-router-dom';
import AlertForm from '@/pages/Alerts/AlertForm';
import AlertsView from '@/pages/Alerts';
import BlockDiagramView from '@/pages/BlockDiagram';
import BulkDevicesView from '@/pages/BulkDevices';
import ConfigurationLayout from '@/layout/ConfigurationLayout';
import Dashboard from '@/pages/Dashboard';
import DashboardLayout from '@/layout/DashboardLayout';
import DashobardNrwView from '@/pages/DashboardNrw';
import DevicesView from '@/pages/Devices/DevicesView';
import DiagramBlockView from '@/pages/DiagramBlock';
import EditModelFileView from './../pages/Uploads/ModelFiles/EditModelFile/index';
import EditStateMachineView from '@/pages/StateMachine/EditStateMachine';
import ErrorView from '@/pages/Error';
import GisFiles from '@/pages/Uploads/GisFiles';
import HistoricalFilesView from './../pages/Uploads/Historical/index';
import InfrastructuresView from '@/pages/Infrastructures';
import InteractiveSimulationReplay from '@/pages/Simulations/InteractiveSimulationReplay.view.jsx';
import InteractiveSimulationView from '@/pages/Simulations/InteractiveSimulation.view.jsx';
import KpiView from '@/pages/Kpi';
import LocationsDetailView from '@/pages/Locations/locationDetail';
import LocationsView from '@/pages/Locations';
import NonRevenueWaterView from '@/pages/NonRevenueWater';
import NwlDashboardView from '@/pages/NWL';
import OrganizationView from '@/pages/Organizations';
import ParameterView from '@/pages/Infrastructures/Parameters';
import ParamSelfCalibrationView from './../pages/Infrastructures/SelfCalibration/index';
import ReportsMroView from '@/pages/ReportsMro';
import SimulationsView from '@/pages/Simulations/SimulationsView';
import StateMachineView from '@/pages/StateMachine';
import UploadBulk from '@/pages/BulkDevices/uploadBulk';
import UploadModelFiles from '@/pages/Uploads/ModelFiles/UploadModelFiles';
import UploadParametersFilesView from './../pages/Uploads/Parameters/UploadParameters/index';
import UploadsView from '@/pages/Uploads';
import UserView from '@/pages/Users';
import ProfileChart from '@/pages/Profiler';
import InteractiveSimulationViewV2 from '@/pages/InteractiveSimulation/index.view.jsx';
import InteractiveSimulationLayout from '@/layout/InteractiveSimulationLayout';
import InteractiveSimulationReplayV2 from '@/pages/InteractiveSimulation/replayInteractiveSimulation.view.jsx';
import NwlDashboardLayout from '@/layout/NWL/NwlDashboardLayout';
import CatchmentView from '@/pages/NWL/CatchmentView';
import DecisionLogView from '@/pages/DecisionLog';
import SourceHealthDashboard from '@/pages/HealthDashboard';
import RoleGuard from '@/guards/roleguard';
import UploadProfilerFiles from './../pages/Uploads/Profilers/UploadProfilers/index';
import MmsClusteredView from '@/pages/Mms/index.jsx';

const NwlOrgID = process.env.VITE_NWL_ORG_ID || '';

const AppRoutes = ({ organizationId = undefined }) => {
  return (
    <Routes>
      <Route path="/error" element={<ErrorView />} />
      <Route path="/profiler" element={<ProfileChart />} />

      {organizationId === NwlOrgID && (
        <Route path="/nwl" element={<NwlDashboardLayout />}>
          <Route path="" element={<NwlDashboardView />} />
          <Route path="catchment" element={<CatchmentView />} />
          <Route path="decision-log" element={<DecisionLogView />} />
        </Route>
      )}

      <Route path="/" element={<DashboardLayout />}>
        <Route path="" element={<Dashboard />} />
        <Route path="/diagram-block/:locationId/:blockId" element={<DiagramBlockView />} />
        <Route path="stateMachines/edit/:stateMachineId" element={<EditStateMachineView />} />
        <Route path="/interactive-simulation-edit/:locationId/:simulationId" element={<InteractiveSimulationView />} />
        <Route path="/interactive-simulation-view/:locationId/:simulationId" element={<InteractiveSimulationReplay />} />
        <Route path="/mro-reports" element={<ReportsMroView />} />
        <Route path="/nrw" element={<DashobardNrwView />} />
        <Route path="/mms" element={<MmsClusteredView />} />
        <Route path="/hydraulic-profiler/:profileId" element={<ProfileChart />} />
        <Route path="/health-dashboard" element={<SourceHealthDashboard />} />
      </Route>

      <Route path="/" element={<ConfigurationLayout />}>
        <Route path="locations" element={<RoleGuard><LocationsView /></RoleGuard>} />
        <Route path="locations/:locationId" element={<RoleGuard><LocationsDetailView /></RoleGuard>} />
        <Route path="infrastructures" element={<RoleGuard><InfrastructuresView /></RoleGuard>} />
        <Route path="infrastructures/parameter/:infraId" element={<RoleGuard><ParameterView /></RoleGuard>} />
        <Route path="infrastructures/parameter/hydroTwin" element={<RoleGuard><ParamSelfCalibrationView /></RoleGuard>} />
        <Route path="upload" element={<RoleGuard><UploadsView /></RoleGuard>} />
        <Route path="upload/gisfiles" element={<RoleGuard><GisFiles /></RoleGuard>} />
        <Route path="upload/historicalfiles" element={<RoleGuard><HistoricalFilesView /></RoleGuard>} />
        <Route path="upload/parameters" element={<RoleGuard><UploadParametersFilesView /></RoleGuard>} />
        <Route path="upload/modelfiles" element={<RoleGuard><UploadModelFiles /></RoleGuard>} />
        <Route path="upload/modelfiles/editFile" element={<RoleGuard><EditModelFileView /></RoleGuard>} />
        <Route path="upload/profilerfiles" element={<RoleGuard><UploadProfilerFiles /></RoleGuard>} />
        <Route path="kpi" element={<RoleGuard><KpiView /></RoleGuard>} />
        <Route path="alerts" element={<RoleGuard><AlertsView /></RoleGuard>} />
        <Route path="alerts/form" element={<RoleGuard><AlertForm /></RoleGuard>} />
        <Route path="alerts/form/:alertId" element={<RoleGuard><AlertForm /></RoleGuard>} />
        <Route path="nonRevenueWater" element={<RoleGuard><NonRevenueWaterView /></RoleGuard>} />
        <Route path="block/diagram" element={<RoleGuard><BlockDiagramView /></RoleGuard>} />
        <Route path="stateMachines" element={<RoleGuard><StateMachineView /></RoleGuard>} />
        <Route path="simulations" element={<RoleGuard><SimulationsView /></RoleGuard>} />
        <Route path="devices" element={<RoleGuard><DevicesView /></RoleGuard>} />
        <Route path="users" element={<RoleGuard><UserView /></RoleGuard>} />

        <Route path="organizations" element={<RoleGuard><OrganizationView /></RoleGuard>} />
        <Route path="bulk" element={<RoleGuard><BulkDevicesView /></RoleGuard>} />
        <Route path="bulk/upload" element={<RoleGuard><UploadBulk /></RoleGuard>} />
      </Route>

      <Route path="/" element={<InteractiveSimulationLayout />}>
        <Route path="/interactive-simulation-v2/:locationId/:simulationId" element={<InteractiveSimulationViewV2 />} />
        <Route path="/replay-interactive-simulation-v2/:locationId/:simulationId" element={<InteractiveSimulationReplayV2 />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
